<template lang="html">
  <div class="merchant-container">
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('message.report') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('message.reportDownload') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="body-container">
      <div class="table-container verifone-panel">
        <div class="table-main">
            <el-table :data="downloadList" style="width: 100%" height="500">
              <el-table-column type="index" width="50" :label="$t('message.No')" />
              <el-table-column prop="reportName" :show-overflow-tooltip="true" :label="$t('message.reportName')"  width="180">
                <template slot-scope="scope">
                  <span v-if='scope.row.reportName =="Terminal List"' size="small">{{ $t('message.TerminalList') }}</span>
                  <span v-if='scope.row.reportName =="Terminal Parameter"' size="small">{{ $t('message.TerminalParameter') }}</span>
                  <span v-if='scope.row.reportName =="Download Task Status"' size="small">{{ $t('message.downloadTaskStatusReport') }}</span>
                  <span v-if='scope.row.reportName =="Relocation Alert"' size="small">{{ $t('message.relocationWarningReport') }}</span>

                </template>
              </el-table-column>
              <el-table-column prop="createdTime" :show-overflow-tooltip="true" :label="$t('message.createTime')" />
              <el-table-column prop="Id" v-if="show"  :label="$t('message.reportId')" width="120" />
              <el-table-column prop="creator" v-if="show"  :label="$t('message.user')" width="120" />
              <el-table-column prop="status" :show-overflow-tooltip="true"  :label="$t('message.status')" width="120" >
                    <template slot-scope="scope">
                      <span v-if='scope.row.status =="创建中"' size="small">{{ $t('message.creating') }}</span>
                      <span v-if='scope.row.status =="已完成"' size="small">{{ $t('message.completed') }}</span>
                    </template>
              </el-table-column>

              <el-table-column prop="username" :show-overflow-tooltip="true" :label="$t('message.creator')" width="120" />
              <el-table-column :label="$t('message.operation')" align="center">
                  <template slot-scope="scope">
                     <el-button  :disabled='scope.row.status =="创建中" ' class="verifone-btn downloadbtn" id = "downloadBtn" type="primary" icon="el-icon-download" plain  @click="downloadReport(scope.row)">{{ $t('message.download') }}</el-button>
                   </template>
              </el-table-column>
            </el-table>
        </div>

        <div class="pagination-main">
          <el-pagination background layout="prev, pager, next" @current-change="queryDownloadList" :current-page="pageNum" :page-count="pages"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Number: '',
      reportName: '',
      username: '',
      createdTime: '',
      creator:'',
      Id:'',
      pageSize: 10,
      pageNum: 1,
      pages: 0,
      show:false,
      status:'',
      currentPage: 1,
      downloadList: [],
      nowTime:''//获取当前实时时间
    };
  },
  mounted() {
    this.queryDownloadList(1);

  },
  methods: {
    queryDownloadList(page) {
      let that = this;
      let obj = {
        pageNum: page
      };

      that.currentPage = page;

      this.$axios({
        method: 'post',
        url: '/marketplace/report/findReportRecordDownloadList',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: obj
      })
        .then(response => {
          if (response.data.code != '00') {
            _this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            return;
          } else {
            this.pages = response.data.data.pages;
            this.downloadList = response.data.data.list;
            console.log('downloadList',this.downloadList);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    downloadReport(row){
  
    var timestamp = Date.parse(new Date(row.createdTime));
    var timesDate = new Date(parseInt(timestamp));
    
    let yy = timesDate.getFullYear();
    let mm = timesDate.getMonth()+1;
    let dd = timesDate.getDate();
    let hh = timesDate.getHours()<10 ? '0'+timesDate.getHours() : timesDate.getHours();
    let mf = timesDate.getMinutes()<10 ? '0'+timesDate.getMinutes() : timesDate.getMinutes();
    let ss = timesDate.getSeconds()<10 ? '0'+timesDate.getSeconds() : timesDate.getSeconds();
    this.nowTime = yy+''+mm+''+dd+''+hh+''+mf+''+ss;
   /* console.log(this.nowTime);
    var reportTime = row.createdTime; */
      let obj = {
          creator: row.creator,
          reportName:row.reportName,
          status:row.status,
          Id:row.Id,
          createdTime : row.createdTime
      };
            this.$axios({
               method:'post',
               url:'/marketplace/report/downloadReport',
               headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
               data:obj,
               timeout: 600000,
               responseType: 'blob'
             }).then(res=>{
              if(res.data.code==99) {
                  this.$notify.error({
                    type: 'error',
                    message: response.data.desc,
                    duration: '3000'
                  })
                  return ;
              }else{
                    let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;' })
                    let url = window.URL.createObjectURL(blob)
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download',row.reportName+'_'+this.nowTime+'.xlsx')
                    document.body.appendChild(link)
                    link.click()

                    //刷新列表
                    this.queryDownloadList(this.currentPage);
                    document.getElementById("downloadBtn").blur();

                    // 删除添加的a链接
                    /*let objLink = document.getElementById('download')
                    document.body.removeChild(objLink)
                    // 释放内存
                    window.URL.revokeOjbectURL(url);*/

              }
            }).catch(error => {
             console.log(error)

             })

    }
  }
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.downloadbtn{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/report/ReportDownload.vue